export default "__VITE_ASSET__D6wb6WwV__"